<template>
  <div>
    <HomeDashboard v-if="user" />
    <HomeContent v-else />
  </div>
</template>
<script setup>
usePageTitle()

const user = useStrapiUser()
definePageMeta({
  fullwidth: true,
})

</script>